const angular = require('angular');
var app = angular.module('learn-controllers');

app.controller('overviewAdminController', [
  'Application',
  function (Application) {
    var self = this;
    self.featureFlags = Application.features.flags();

    self.showChartGrouping = (chartGrouping) => {
      document
        .getElementById('chart-grouping-' + chartGrouping)
        .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    };
  },
]);
